import cookie from 'react-cookies'
import axios from 'axios'
import ApiURL from './ApiUrl'

export const obtainFolderVideos = async (albumPath) => {
  let allVideos

  await axios
    .get(
      `${ApiURL}/api/vimeovideos${albumPath.slice(0, -1)}/`,

      {
        headers: {
          Authorization: 'Bearer ' + cookie.load('accessToken'),
        },
      }
    )
    .then((response) => {
      allVideos = response.data.data
    })
    .catch((error) => {
      console.log(error)
      if (error.status == 401) {
        // refreshToken()
        // obtainFolderVideos(albumPath)
      } else {
        console.log(error.status)
      }
    })

  return allVideos
}
